import React from 'react'
import './SchTable.css'

const SchTable = ({ dataSch }) => {
  return (
    <div className="app__table-schedule">
    <table className="app__background-bk table-sch ">
        <thead className="app__sch__thead">
            <tr className="app__sch_tr" >
                <th className="app__sch_th">Field/Time</th>
                <th className="app__sch_th">A</th>
                <th className="app__sch_th">B1</th>
                <th className="app__sch_th">B2</th>
                <th className="app__sch_th">C1</th>
                <th className="app__sch_th">C2</th>
                <th className="app__sch_th">D1</th>
                <th className="app__sch_th">D2</th>
                <th className="app__sch_th">E1</th>
                <th className="app__sch_th">E2</th>
                <th className="app__sch_th">F</th>

            </tr>
        </thead>
        <tbody className="sch__tbody">
            {dataSch.map((row, index) => (
                <tr className="app__sch_tr" key={index}>
                    <td className="sData">{row.time}</td>
                    <td className="sData">{row.fieldA}</td>
                    <td className="sData">{row.fieldB1}</td>
                    <td className="sData">{row.fieldB2}</td>
                    <td className="sData">{row.fieldC1}</td>
                    <td className="sData">{row.fieldC2}</td>
                    <td className="sData">{row.fieldD1}</td>
                    <td className="sData">{row.fieldD2}</td>
                    <td className="sData">{row.fieldE1}</td>
                    <td className="sData">{row.fieldE2}</td>
                    <td className="sData">{row.fieldF}</td>

                </tr>
            ))}
        </tbody>
    </table>
</div>
);
}

export default SchTable